import { GuardedComponent } from '../components/guarded-component';
import { PermissionErrorComponent } from '../components/permission-error.component';
import { PlanReviewDashboardPage } from '../features/plan-review-dashboard/plan-review-dashboard.page';
import { UserPermissionName } from '../models/user-permission-name';

const isPlanEnabled = process.env.REACT_APP_PLAN_FLAG === 'true';

export const PlanReviewsRoute = {
  path: '/plan-reviews',
  name: 'Plan Review Dashboard',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PLAN_REVIEW_DASHBOARD]}>
          {isPlanEnabled ? <PlanReviewDashboardPage /> : <PermissionErrorComponent />}
        </GuardedComponent>
      ),
    },
  ],
};
